module.exports = __webpack_public_path__ + "img/icon-apple.8327865b.svg";